import { Button, Divider, Grid, Tooltip, Typography } from "@material-ui/core";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import { PessoaPostModel } from "model/api/gestao/pessoa/pessoa-post-model";
import {
  EnumBloquearContratos,
  EnumBloquearContratosLabel,
  EnumBloquearContratosTooltip,
  normalizeBloquearContratos,
} from "model/enums/enum-bloquear-contratos";
import { EnumTipoPessoas } from "model/enums/enum-tipo-pessoas";
import { useCallback, useEffect, useState } from "react";
import { useSessaoAtual } from "services/app";
import { CircularLoading } from "views/components";
import { AccordionSaurus } from "views/components/accordions/accordion-saurus/accordion-saurus";
import { TextFieldSaurus } from "views/components/controles/inputs";
import { SalvarIcon } from "views/components/icons";
import { useThemeQueries } from "views/theme";
import { useStyles } from './accordion-cliente-acesso-avisos-styles'

type Props = {
  cliente: PessoaPostModel;
  onSubmit: (model: PessoaPostModel) => Promise<boolean>
  carregando: boolean
}

type CamposClienteProps = {
  bloquear: EnumBloquearContratos;
  mensagem: string;
}

const opcoesBloqueio = [
  EnumBloquearContratos.NaoBloquear,
  EnumBloquearContratos.BloquearContratos,
  EnumBloquearContratos.BloquearApenasCnpj,
]

export const AccordionClienteAcessoAvisos = ({ cliente, onSubmit, ...props }: Props) => {
  const { theme } = useThemeQueries()
  const [openAccordion, setOpenAccordion] = useState<boolean>(false)
  const classes = useStyles()
  const { tipoUsuario } = useSessaoAtual()
  const [carregandoInterno, setCarregandoInterno] = useState<boolean>(false)

  const [campos, setCampos] = useState<CamposClienteProps>({
    bloquear: normalizeBloquearContratos(cliente.bloquearContratos),
    mensagem: cliente.mensagemAosContratos
  })

  useEffect(() => {
    setCampos({
      bloquear: normalizeBloquearContratos(cliente.bloquearContratos),
      mensagem: cliente.mensagemAosContratos
    })
  }, [cliente.bloquearContratos, cliente.mensagemAosContratos])


  const handleSubmit = useCallback(async (e: React.SyntheticEvent) => {
    try {

      setCarregandoInterno(true)
      e.preventDefault()

      const res = await onSubmit({
        ...cliente,
        mensagemAosContratos: campos.mensagem,
        bloquearContratos: campos.bloquear
      })

      if (!res) {
        setCampos({
          bloquear: normalizeBloquearContratos(cliente.bloquearContratos),
          mensagem: cliente.mensagemAosContratos
        })
      }
    }
    finally {
      setCarregandoInterno(false)
    }
  }, [campos.bloquear, campos.mensagem, cliente, onSubmit])

  const handleBloquearChange = useCallback((_: React.MouseEvent<HTMLElement>, value: EnumBloquearContratos | null) => {
    if (value === null) return
    setCampos(prev => ({
      ...prev,
      bloquear: value
    }))
  }, [])

  const carregando = carregandoInterno && props.carregando

  return (
    <>
      <AccordionSaurus
        labelPrimary="Acesso e Avisos"
        tipoExpand="bold"
        noPaperRoot={false}
        heightDivider={2}
        showDivider={openAccordion}
        colorDivider={theme.palette.primary.main}
        colorExpand={theme.palette.primary.main}
        expanded={openAccordion}
        onChange={() => setOpenAccordion(prev => !prev)}
      >
        <Grid container spacing={1} style={{
          position: 'relative'
        }}>
          {carregando && <CircularLoading tipo="FULLSIZED" />}
          {tipoUsuario() !== EnumTipoPessoas.Funcionario && <>
            <Grid item xs={12}>
              <form onSubmit={handleSubmit}>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <div className={classes.switchInputContainer}>
                      <Typography className={classes.bloqueioLabel}>
                        Bloquear Acesso ao Sistema
                      </Typography>
                      <ToggleButtonGroup
                        exclusive
                        size="small"
                        value={campos.bloquear}
                        onChange={handleBloquearChange}
                        className={classes.bloqueioToggleGroup}
                      >
                        {opcoesBloqueio.map((opcao) => (
                          <ToggleButton
                            key={opcao}
                            value={opcao}
                            className={classes.bloqueioToggleButton}
                          >
                            <Tooltip
                              arrow
                              placement="top"
                              title={EnumBloquearContratosTooltip[opcao]}
                            >
                              <span>{EnumBloquearContratosLabel[opcao]}</span>
                            </Tooltip>
                          </ToggleButton>
                        ))}
                      </ToggleButtonGroup>
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <TextFieldSaurus
                      label="Mensagem ao Usuário"
                      name="mensagem"
                      value={campos.mensagem}
                      allowSubmit
                      minRows={3}
                      multiline
                      placeholder="Digite aqui a mensagem que deseja que o usuário visualize ao acessar o sistema."
                      onChange={ev => setCampos(prev => {
                        return {
                          ...prev,
                          mensagem: ev.target.value
                        }
                      })}
                    />
                  </Grid>
                  <Grid item xs={12} container justifyContent="flex-end">
                    <Grid item container justifyContent="flex-end">
                      <Grid item xs={12} md={4}>
                        <Button variant="contained" color='primary' fullWidth type="submit">
                          <SalvarIcon tipo='BUTTON_PRIMARY' />
                          Salvar
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </form>
            </Grid>
            <Grid item xs={12}>
              <Divider style={{ background: theme.palette.divider, margin: '8px 0' }} />
            </Grid>
          </>}
        </Grid>
      </AccordionSaurus>
    </>
  );
};
